import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Menu, X, User, Shield, Settings, LogOut, Lock } from "lucide-react";
import SecurityBadge from "./SecurityBadge";
const Header = () => {
  const {
    user,
    signOut,
    isAdmin
  } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();
  const handleSignOut = async () => {
    await signOut();
    navigate("/");
  };
  const userInitials = user?.email?.substring(0, 2).toUpperCase() || "U";
  return <header className="bg-white shadow-sm border-b">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary-dark rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">NL</span>
            </div>
            <span className="text-xl font-bold text-gray-900">NL  </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <Link to="/" className="text-gray-700 hover:text-primary-dark transition-colors">
              Home
            </Link>
            <Link to="/dna-pricing" className="text-gray-700 hover:text-primary-dark transition-colors">
              DNA Testing
            </Link>
            <Link to="/gender-reveal" className="text-gray-700 hover:text-primary-dark transition-colors">
              Gender Reveal
            </Link>
            <Link to="/drug-testing" className="text-gray-700 hover:text-primary-dark transition-colors">
              Drug Testing
            </Link>
            <Link to="/biometric-screening" className="text-gray-700 hover:text-primary-dark transition-colors">
              Biometric Screening
            </Link>
            <Link to="/booking" className="text-gray-700 hover:text-primary-dark transition-colors">
              Book Appointment
            </Link>
            
            <Link to="/affiliate" className="text-gray-700 hover:text-primary-dark transition-colors">
              Partner Program
            </Link>
            {isAdmin && (
              <Link to="/admin" className="text-gray-700 hover:text-primary-dark transition-colors flex items-center gap-1">
                <Shield className="h-4 w-4" />
                Admin
              </Link>
            )}
            <SecurityBadge variant="compact" />
          </nav>

          {/* Right side items */}
          <div className="flex items-center space-x-4">
            {/* Mobile menu button */}
            <Button 
              variant="ghost" 
              size="sm" 
              className="md:hidden" 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={isMenuOpen ? "Close navigation menu" : "Open navigation menu"}
              aria-expanded={isMenuOpen}
            >
              {isMenuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && <div className="md:hidden border-t py-4">
            <nav className="flex flex-col space-y-4">
              <Link to="/" className="text-gray-700 hover:text-primary-dark transition-colors" onClick={() => setIsMenuOpen(false)}>
                Home
              </Link>
              <Link to="/dna-pricing" className="text-gray-700 hover:text-primary-dark transition-colors" onClick={() => setIsMenuOpen(false)}>
                DNA Testing
              </Link>
              <Link to="/gender-reveal" className="text-gray-700 hover:text-primary-dark transition-colors" onClick={() => setIsMenuOpen(false)}>
                Gender Reveal
              </Link>
              <Link to="/drug-testing" className="text-gray-700 hover:text-primary-dark transition-colors" onClick={() => setIsMenuOpen(false)}>
                Drug Testing
              </Link>
              <Link to="/biometric-screening" className="text-gray-700 hover:text-primary-dark transition-colors" onClick={() => setIsMenuOpen(false)}>
                Biometric Screening
              </Link>
              <Link to="/booking" className="text-gray-700 hover:text-primary-dark transition-colors" onClick={() => setIsMenuOpen(false)}>
                Book Appointment
              </Link>
              <Link to="/affiliate" className="text-gray-700 hover:text-primary-dark transition-colors" onClick={() => setIsMenuOpen(false)}>
                Partner Program
              </Link>
              {isAdmin && (
                <Link to="/admin" className="text-gray-700 hover:text-primary-dark transition-colors flex items-center gap-1" onClick={() => setIsMenuOpen(false)}>
                  <Shield className="h-4 w-4" />
                  Admin
                </Link>
              )}
              <div className="flex justify-start">
                <SecurityBadge variant="compact" />
              </div>
            </nav>
          </div>}
      </div>
    </header>;
};
export default Header;